import { render, staticRenderFns } from "./NewData.vue?vue&type=template&id=40584bad"
import script from "./NewData.vue?vue&type=script&lang=ts"
export * from "./NewData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports